
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { BottomDrawer } from 'common/views/atoms/BottomDrawer/BottomDrawer'
import { closeStatusDrawer } from 'manager/redux/referral_status'
import { StatusHoldForm } from './StatusHoldForm'
import { StatusReleaseForm } from './StatusReleaseForm'

const HoldReleaseDrawer = ({ location, closeStatusDrawer }) => {
    const hold = location.query.hold
    const release = location.query.release

    let title
    if (hold) {
      title = 'Long-term hold'
    }

    if (release) {
      title = 'Release to Opcity'
    }

    return (
        <BottomDrawer
            title={title}
            className="HoldReleaseDrawer"
            onClose={closeStatusDrawer}
            isOpen={!!(hold || release)}
            fullscreen={hold || release}>
            {hold && <StatusHoldForm />}
            {release && <StatusReleaseForm />}
        </BottomDrawer>
    )
}

const selector = (state) => {
  return {}
}

const actions = {
  closeStatusDrawer,
}

const withRedux = connect(selector, actions)

export const ReferralHoldReleaseDrawer = withRedux(withRouter(HoldReleaseDrawer))
